import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { motion } from 'framer-motion'

export const Button = css`
  border: none;
  background: none;
  color: var(--clvn-blue-700);

  padding: 0;
  min-width: 0;

  :hover {
    background: none;
  }

  &.open {
    color: #2196f3;
  }
`

export const Title = styled.h1`
  margin: 0;
  margin-bottom: 20px;
  color: var(--clvn-blue-700);
  font-size: 12px;
  font-weight: 700;
`

export const FindAndReplace = styled.div`
  display: grid;
  gap: 15px;
  grid-template-columns: 1fr 1fr;
`

export const Label = styled.label`
  margin: 0;
  margin-bottom: 2px;
  color: var(--clvn-blue-400);
  font-size: 12px;
  font-weight: 400;
`

export const MatchCaseButton = css`
  &:hover {
    background: none;
  }
`

export const Count = styled.div`
  font-size: 11px;
  line-height: 21px;
  color: var(--clvn-blue-700);
  margin-bottom: 25px;
  display: flex;
  align-items: center;
`

export const Found = styled.div`
  margin-inline: 10px;
`

export const ChevronButton = css`
  background: var(--clvn-blue-700);
  color: #fff;
  border-radius: 4px;
  width: 21px;
  height: 21px;

  &:hover {
    background: #1fabe3;
  }
`

export const Subtitle = styled.h2`
  margin: 0;
  margin-bottom: 5px;
  color: var(--clvn-blue-500);
  font-size: 12px;
  font-weight: 700;
`

export const List = styled.ul`
  list-style: none;
  padding: 0;
`

export const ListItem = styled(motion.li)`
  background-color: var(--clvn-blue-100);
  border: 1px solid var(--clvn-blue-200);
  padding: 10px 21px;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  color: var(--clvn-blue-700);
`

export const Change = styled.div`
  display: flex;
  align-items: center;
`

export const ChangesCount = styled.span`
  font-size: 11px;
  color: var(--clvn-blue-700);
`

export const Term = styled.span`
  font-size: 12px;
  line-height: 18px;
`

export const UndoButton = css`
  border-color: var(--clvn-blue-500);
  color: var(--clvn-blue-700);
  padding: 6px 8px !important;
  font-size: 11px !important;
  font-weight: 500 !important;
  line-height: 1;
  min-width: 0 !important;
  margin-left: 10px;

  &:hover {
    border-color: #1fabe3;
    background-color: #eff8fd;
  }
`

export const ReplaceButton = css`
  text-transform: none;
  color: var(--clvn-blue-700);
  border-color: var(--clvn-blue-500);
  padding: 6px 8px !important;
  font-size: 11px !important;

  &:hover {
    border-color: #1fabe3;
    background-color: #eff8fd;
  }
`

export const ReplaceAllButton = css`
  border-color: var(--clvn-blue-500);
  background-color: var(--clvn-blue-500);
  color: #fff;
  padding: 6px 8px !important;
  font-size: 11px !important;
  font-weight: 500 !important;
  line-height: 1;
  min-width: 0 !important;
  margin-left: 10px;
  text-transform: none;

  &:hover {
    background-color: var(--clvn-blue-700);
    border-color: var(--clvn-blue-700);
  }
`

export const Footer = styled.footer`
  background-color: #eef3f5;
  border-top: 1px solid var(--clvn-blue-200);
  padding: 10px 10px 10px 25px;
  border-radius: 0 0 8px 8px;
  display: flex;
  justify-content: flex-end;
`
